/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgZoomMonochromatic = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z'
      fill='#151D23'
      fillOpacity={0.32}
    />
    <path
      d='M10.2107 7.03189L12.1942 5.58286C12.3664 5.44033 12.5 5.47597 12.5 5.7343V10.1526C12.5 10.4466 12.3367 10.411 12.1942 10.3041L10.2107 8.85802V7.03189ZM3.5 5.74617V9.04211C3.50297 9.78741 4.11168 10.3872 4.85401 10.3842H9.65836C9.79495 10.3842 9.90482 10.2744 9.90482 10.1408V6.84482C9.90185 6.09952 9.29314 5.49972 8.55081 5.50269H3.74645C3.60986 5.50269 3.5 5.61255 3.5 5.74617Z'
      fill='white'
    />
  </svg>
)
export default SvgZoomMonochromatic
